import React from "react";

import Image from "next/image";

import CALSSALogo from "public/images/enerflo-calssa-logo.png";
import FlaSEIALogo from "public/images/enerflo-flaseia-logo.png";
import RSALogo from "public/images/enerflo-rsa-logo.png";
import SEIALogo from "public/images/enerflo-seia-logo.png";

import Button from "components/button";
import Heading from "components/heading";

import HeroSection from "../../hero-section";

const items = [
  {
    title: "Residential Solar Association (RSA)",
    description:
      "The Residential Solar Association (RSA) unites leading companies to advance the residential solar industry through collaboration, education, and advocacy. Membership helps Enerflo stay informed, influence policy, and support industry growth.",
    image: RSALogo,
    cta: { text: "Learn About the RSA", url: "https://www.residentialsolarassociation.com/" },
  },
  {
    title: "Solar Energy Industries Association (SEIA)",
    description:
      "(SEIA) is the national trade association for America’s solar industry. SEIA drives federal policy, advocates for clean energy, and promotes sustainable industry growth. Through this membership, Enerflo supports a strong, unified voice for solar at the national level.",
    image: SEIALogo,
    cta: { text: "Learn About SEIA", url: "https://seia.org/" },
  },
  {
    title: "California Solar & Storage Association (CALSSA)",
    description:
      "The California Solar & Storage Association (CALSSA) is the state’s largest clean energy trade association. CALSSA advocates for smart policy, fair regulation, and market growth in California. Membership keeps Enerflo connected to key legislative developments and industry initiatives in one of the nation’s leading solar markets.",
    image: CALSSALogo,
    cta: { text: "Learn About CALSSA", url: "https://calssa.org/" },
  },
  {
    title: "Florida Solar Energy Industries Association (FlaSEIA)",
    description:
      "The Florida Solar Energy Industries Association (FlaSEIA) represents and supports solar businesses across Florida. FlaSEIA advocates for fair policies, industry standards, and market expansion. Membership helps Enerflo stay engaged in Florida’s evolving solar landscape and support a strong regional solar community.",
    image: FlaSEIALogo,
    link: "https://www.flaseia.org/",
    cta: { text: "Learn About FlaSEIA", url: "https://www.flaseia.org/" },
  },
];

const title = "Enerflo is a Proud Member of these Industry Organizations";

const Memberships = () => (
  <div className="bg-navy">
    <HeroSection title={title}>
      <HeroSection.Content>
        <HeroSection.Header className="text-white text-center">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <p className="text-lg text-gray-100 mx-auto md:w-3/4 lg:w-2/3 md:text-center">
          Driving the Future of Residential Solar Through Industry Collaboration and Advocacy
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 mt-8 md:mt-20">
          {items.map(item => (
            <div
              key={item.title}
              className="flex-1 flex flex-col justify-between gap-6 rounded-lg p-4 md:py-8 text-center bg-white"
            >
              <div>
                <figure className="flex items-center justify-center max-w-[15rem] mx-auto">
                  <Image src={item.image} alt={`${item.title} Logo`} />
                </figure>
                <p className="mt-2 text-gray-500 text-base">{item.description}</p>
              </div>
              <Button variant="outline" href={item.cta.url}>
                {item.cta.text}
              </Button>
            </div>
          ))}
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default Memberships;
